// *************************************************************
// 1.0 : Scroll To Section
// *************************************************************

document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
  anchor.addEventListener('click', (e) => {
    document.querySelector(anchor.getAttribute('href')).scrollIntoView({
      behavior: 'smooth',
    });
    e.preventDefault();
  });
});

// *************************************************************
// 2.0 : Wrap editor iframes (WYSIWYG embeds)
// *************************************************************

const editorIframeWrapperClass = 'editor-text__iframe-wrapper';

const wrapEditorIframe = (iframe) => {
  if (iframe.parentElement?.classList.contains(editorIframeWrapperClass)) {
    return;
  }

  const wrapper = document.createElement('div');
  wrapper.className = editorIframeWrapperClass;
  const { parentNode } = iframe;

  const isOnlyIframeInParagraph =
    parentNode.tagName === 'P' &&
    [...parentNode.childNodes].every(
      (node) => node === iframe || (node.nodeType === Node.TEXT_NODE && !node.textContent.trim()),
    );

  if (isOnlyIframeInParagraph) {
    parentNode.replaceWith(wrapper);
    wrapper.appendChild(iframe);
    return;
  }

  parentNode.insertBefore(wrapper, iframe);
  wrapper.appendChild(iframe);
};

document.querySelectorAll('.content-module .editor-text iframe').forEach(wrapEditorIframe);
